import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private _showChat = new BehaviorSubject<boolean>(false);
  showChat$ = this._showChat.asObservable();

  toggleChat() {
    console.log('ChatService: toggleChat');
    this._showChat.next(!this._showChat.value);
  }
}